














import { Component, Vue, Prop } from 'vue-property-decorator'
import { USER_CENTER_URL } from '@/apps/open/constants'
import Button from '@/apps/open/components/Button'
import store from '@/apps/open/store'

@Component({
  components: {
    Button
  },
  data: () => ({
    USER_CENTER_URL
  })
})
export default class TransferSuperAdminNoticeDialogBody extends Vue {
  get isPrivate () {
    return store.getters['isPrivate']
  }
}
